import {Component, Inject, OnInit, PLATFORM_ID} from '@angular/core';
import {AddressType} from '../interface/address-type';
import {Address} from '../interface/address';
import {RequestMapperService} from 'src/app/request-mapper.service';
import {AddressTransmissionService} from 'src/app/raintree/transmission/address-transmission/address-transmission.service';
import {AddressFunctionService} from '../service/address-function.service';
import {RaintreeResponse} from 'src/app/raintree/interface/raintree-response';
import {GlobalService} from 'src/app/services/global.service';
import {isPlatformBrowser} from '@angular/common';
import {BrowserAPIService} from "@bloomscorp/ngbase";
import {FormControl, Validators} from "@angular/forms";

@Component({
	selector: 'fb-address-comp',
	templateUrl: './address.component.html',
	styleUrls: ['./address.component.scss']
})
export class AddressComponent implements OnInit {

	public addressList: Address[] = [];
	public addressType: AddressType = {} as AddressType;
	public isAddressPopupClosed: boolean = false;
	public addressData: Address = {} as Address;
	public billingAddress: Address[] = [];
	public shippingAddress: Address[] = [];
	public isCheckoutPage: boolean = false;
	public isAddShippingButtonClicked = false;
	public isBrowser: boolean = false;

	constructor(
		private _addressTransmission: AddressTransmissionService,
		private _addressService: AddressFunctionService,
		public _globalService: GlobalService,
		private _browser: BrowserAPIService,
		@Inject(PLATFORM_ID) private _platformId: Object
	) {

		this.isBrowser = isPlatformBrowser(this._platformId);
	}

	public closeAddressPopup(): void {
		this.isAddressPopupClosed = false;
		this._globalService.popUpOpenClose(false);
		this.reloadList();
	}

	public openAddressPopup(
		addOrEdit: string,
		isDefault: boolean,
		isBilling: boolean
	): void {
		this.addressType.type = addOrEdit;
		this.addressType.isDefault = isDefault;
		this.addressType.isBilling = isBilling;
		this.isAddressPopupClosed = true;
		this._globalService.popUpOpenClose(true);
	}

	public reloadList(): void {
		this.addressList = [...this.addressList];
		this.fetchUserAddressList();
	}

	public passDataInForm(data: Address): void {
		this.addressData = data
		this.openAddressPopup(
			'edit',
			(data.primaryBillingAddress || data.primaryShippingAddress),
			data.addressType == 'BILLING'
		)
	}

	public ngOnInit(): void {
		this.fetchUserAddressList(); //:TODO  uncomment  this line after api implementation

		if (this.isBrowser){
			this.isCheckoutPage = window.location.href.includes(RequestMapperService.CHECKOUT);
		}

		this.isAddShippingButtonClicked = this._addressService.addShipmentButtonClicked;
	}

	public fetchUserAddressList(): void {
		this._addressTransmission.getAddressList(
			RequestMapperService.GET_ADDRESS_LIST,
			(): void => {
			},
			(): void => {
			},
			(response: Address[]): void => {
				if (response.length > 0) {
					this.addressList = response;
					this.sortingAddress();
				}
			},
			(): void => {
			},
			(): void => {
			}
		)
	}

	public sortingAddress(): void {
		this.billingAddress = [];
		this.shippingAddress = [];

		this.addressList.forEach((address: Address): void => {
			if (address.addressType === 'BILLING') this.billingAddress.push(address)
			if (address.addressType === 'SHIPPING') this.shippingAddress.push(address);
		});

		//for 0 indexing default address
		if (this.billingAddress.length > 0) {

			const primaryBillingAddressIndex: number = this.billingAddress.findIndex(
				(address: Address) => address.primaryBillingAddress
			); //  0 index primaryShippingAddress

			const element: Address = this.billingAddress.splice(primaryBillingAddressIndex, 1)[0];
			this.billingAddress.splice(0, 0, element); // to place the default address on top

		}

		if (this.shippingAddress.length > 0) {

			const primaryShippingAddressIndex: number = this.shippingAddress.findIndex(
				(address: Address) => address.primaryShippingAddress
			); //  0 index primaryShippingAddress0

			const elementShipping: Address = this.shippingAddress.splice(primaryShippingAddressIndex, 1)[0];
			this.shippingAddress.splice(0, 0, elementShipping); // to place the default address on top
		}
	}

	public deleteAddress(addressData: Address, addressType: string, index: number): void {

		this._addressTransmission.deleteAddress(
			RequestMapperService.DELETE_ADDRESS+addressData.id,
			{} as Address,
			(): void => {
			},
			(): void => {
			},
			(response: RaintreeResponse): void => {
				if(addressType === 'SHIPPING') {
					this.shippingAddress.splice(index, 1);
				}
				else{
					this.billingAddress.splice(index, 1);
				}
			},
			(): void => {
			},
			(): void => {
			}
		)

	}
}
